import { memo } from 'react';
import type { FunctionComponent, ReactNode } from 'react';

import Text from '../../../generic/Text';

type JiraSettingsSectionProps = {
  heading: string;
  subHeading?: string | ReactNode;
};

/**
 * A section of the Jira settings page.
 */
const JiraSettingsSection: FunctionComponent<JiraSettingsSectionProps> = memo(({
  heading,
  subHeading,
  children,
}) => (
  <section className="jira-settings__section">
    <Text.H2>
      {heading}
    </Text.H2>
    {subHeading && (
      <div className="margin-top-xs margin-bottom-sm">
        <Text.Paragraph>
          {subHeading}
        </Text.Paragraph>
      </div>
    )}
    {children}
  </section>
));

JiraSettingsSection.displayName = 'JiraSettingsSection';

export default JiraSettingsSection;
